import { AsideMenuItem } from './aside-menu-item';
import { AsideMenuItemWithSub } from './aside-menu-item-with-sub';
import { Loading } from 'components/loading';
import { useAuth } from 'features/auth/contexts/auth';
import { Page } from 'features/shared/model';

export function AsideMenuSettings() {
  const { isGranted, currentPermissions } = useAuth();

  const canReadWorkPatterns = isGranted(Page.WorkPattern, 'read');
  const canReadWorkPatternsSubMenu = isGranted(Page.WorkPattern, 'read');
  const canReaAISettings = isGranted(Page.AISettings, 'read');
  const canReaWebSiteUrl = isGranted(Page.WebSiteUrl, 'read');
  const canReaSalesOfferSetup = isGranted(Page.SalesOfferList, 'read');
  const canReadNewsAndArticles = isGranted(Page.Blog, 'read');
  const canReadBlogs = isGranted(Page.Blog, 'read');
  const canReadTrafficSource = isGranted(Page.TrafficSource, 'read');
  const canNewVehicleSettings = isGranted(Page.NewVehicleSettings, 'read');
  const canReadBranchReferences = isGranted(Page.BranchReferences, 'read');
  const canReadEvensAndOffers = isGranted(Page.EventsAndOffers, 'read');
  const canReadEmployees = isGranted(Page.Employees, 'read');
  const canReadFrequentlyAskingQuestion = isGranted(Page.FrequentlyAskingQuestion, 'read');

  return currentPermissions ? (
    <>
      <div className="text-gray-400 mb-7 fs-7 text-uppercase">SETTINGS & CONTENT</div>

      {canReaAISettings && (
        <AsideMenuItemWithSub to="/ai-settings" title="AI settings" icon="/media/icons/custom/abstract-37.svg">
          <AsideMenuItem to="/ai-settings/templates" title="AI Templates" hasBullet />
          <AsideMenuItem to="/ai-settings/vehicle-data" title="AI Vehicle Data" hasBullet />
        </AsideMenuItemWithSub>
      )}

      {canReadBlogs && <AsideMenuItem to="/blog" icon="/media/icons/duotune/general/gen070.svg" title="Blog" />}

      {canReadBranchReferences && (
        <AsideMenuItem to="/branches" icon="/media/icons/custom/branch-refs.svg" title="Branches Reference Book" />
      )}

      {canReadEvensAndOffers && (
        <AsideMenuItemWithSub
          to="/events-and-offers"
          title="Events List"
          icon="/media/icons/duotune/general/gen071.svg"
        >
          {canReadEmployees && <AsideMenuItem to="/events-and-offers/events-list" title="Events List" hasBullet />}
          <AsideMenuItem to="/events-and-offers/events-participants" title="Events Participants" hasBullet />
        </AsideMenuItemWithSub>
      )}

      {canReadFrequentlyAskingQuestion && (
        <AsideMenuItem
          to="/frequently-asking-questions"
          icon="/media/icons/custom/message-question.svg"
          title="Frequently Asking Questions"
        />
      )}

      {canReaAISettings && (
        <AsideMenuItem to="/new-cars-videos" icon="/media/icons/custom/youtube1.svg" title="New Cars Videos" />
      )}

      {canNewVehicleSettings && (
        <AsideMenuItem
          to="/new-vehicle-settings"
          icon="/media/icons/custom/new-vehicle-settings.svg"
          title="New Vehicle Settings"
        />
      )}

      {canReadNewsAndArticles && (
        <AsideMenuItem
          to="/news-and-articles"
          icon="/media/icons/duotune/general/gen070.svg"
          title="News and articles"
        />
      )}

      {canReadBlogs && (
        <AsideMenuItemWithSub to="/site-settings" title="Site settings" icon="/media/icons/custom/element-plus.svg">
          {canReadBlogs && (
            <AsideMenuItem to="/site-settings/content-configuration" title="Content Configuration" hasBullet />
          )}
          {canReadBlogs && (
            <AsideMenuItem to="/site-settings/sales-offer-setup" title="Sales Offer Setup List" hasBullet />
          )}
          {canReadBlogs && <AsideMenuItem to="/site-settings/website-url" title="Website URLs Log" hasBullet />}
        </AsideMenuItemWithSub>
      )}

      {canReadTrafficSource && (
        <AsideMenuItem to="/traffic-source" icon="/media/icons/custom/traffic-source.svg" title="Traffic Source" />
      )}
    </>
  ) : (
    <Loading />
  );
}
